import React from 'react'
import { TopicModelAsEditorWithFeedbacksCount } from 'front-end/src/pages/topic-edit-page/TopicEditPage'
import { TopbarDrawer } from '../drawers/TopbarDrawer'
import { Trans } from '@lingui/macro'
import { ResourceFeedbackDrawerContent } from '../drawers/resource-feedback-drawer/ResourceFeedbackDrawerContent'
import { ResourceVersionsDrawerContent } from '../drawers/resource-versions-drawer/ResourceVersionsDrawerContent'
import { ResourceGeneralDrawerContent } from './ResourceGeneralDrawerContent'
import { ResourceSettingsDrawerContent } from './ResourceSettingsDrawerContent'
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs
} from 'front-end/src/components'

export interface IResourceSettingsDrawerProps {
  topic: TopicModelAsEditorWithFeedbacksCount
  show: boolean
  onHide: () => void
  dataTest?: string
}

const ResourceDrawer = ({
  topic,
  show,
  onHide,
  dataTest = 'Settings'
}: IResourceSettingsDrawerProps) => {
  if (!topic) {
    return null
  }

  return (
    <TopbarDrawer
      show={show}
      onHide={onHide}
      isEditMode
      topicType={topic.draftVersion?.topic_type}
    >
      <Tabs data-test={dataTest} size="lg" isLazy>
        <TabList>
          <Tab w="25%" borderRadius={0} data-test="GeneralButton">
            <Trans>General</Trans>
          </Tab>
          <Tab w="25%" borderRadius={0} data-test="SettingsButton">
            <Trans>Settings</Trans>
          </Tab>
          <Tab w="25%" borderRadius={0} data-test="FeedbackButton">
            <Trans>Feedback</Trans>
          </Tab>
          <Tab w="25%" borderRadius={0} data-test="VersionsButton">
            <Trans>Versions</Trans>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <ResourceGeneralDrawerContent topic={topic} />
          </TabPanel>
          <TabPanel p={0}>
            <ResourceSettingsDrawerContent topic={topic} />
          </TabPanel>
          <TabPanel p={0}>
            <ResourceFeedbackDrawerContent topicId={topic.id} />
          </TabPanel>
          <TabPanel p={0}>
            <ResourceVersionsDrawerContent isEditMode topicId={topic.id} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </TopbarDrawer>
  )
}

export default ResourceDrawer
